<app-hierarchy [hierarchyListA]="hierarchyListA$ | async"
               [hierarchyListB]="hierarchyListB$ | async"
               [hierarchyListC]="hierarchyListC$ | async"
               [topHierarchyData]="topHierarchyData$ | async"
               [bottomHierarchyData]="bottomHierarchyData$ | async"
               [storeCount]="storeCount$ | async"
               [chain]="chain"
               [selectedStoreLevel]="selectedStoreLevel"
               [selectedStoreLevelParent]="selectedStoreLevelParent"
               [oldKey]="oldKey"
               [selectedHomeOffice]="selectedHomeOffice"
               (addHierarchyLevel)="addLevel($event)"
               (deleteHierarchyLevel)="deleteLevel($event)"
               (updateHierarchyLevel)="updateLevel($event)"
               (addHierarchyStore)="addStore($event)"
               (deleteHierarchyStore)="deleteStore($event)"
               (updateHierarchyStore)="updateStore($event)"
></app-hierarchy>
